// Batch G — view switcher for /intelligence.
//
// 3-way pill: Prices · Metrics · Verdicts. Identical visual language to
// the StageTabs / Portfolio filter row — radio-group semantics so
// keyboard arrows work inside the group.

import { DollarSign, Gauge, LayoutGrid, Sparkles } from "lucide-react";

const VIEWS = [
  { id: "basic",    label: "Basic",    Icon: LayoutGrid, hint: "Default portfolio view" },
  { id: "prices",   label: "Prices",   Icon: DollarSign, hint: "Asking vs counter" },
  { id: "metrics",  label: "Metrics",  Icon: Gauge,      hint: "Cap, CoC, DSCR, CF" },
  { id: "verdicts", label: "Verdicts", Icon: Sparkles,   hint: "Grade shifts" },
];

export default function IntelligenceViewTabs({ value, onChange }) {
  return (
    <div
      role="radiogroup"
      aria-label="View"
      data-testid="intelligence-view-tabs"
      className="inline-flex items-center gap-0.5 rounded-xl border border-slate-200 bg-slate-50 p-1"
    >
      {VIEWS.map((v) => {
        const Icon = v.Icon;
        const active = value === v.id;
        return (
          <button
            key={v.id}
            role="radio"
            aria-checked={active}
            data-testid={`view-tab-${v.id}`}
            onClick={() => onChange(v.id)}
            className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-all ${
              active
                ? "bg-white text-indigo-700 shadow-sm ring-1 ring-slate-200"
                : "text-slate-600 hover:text-slate-900"
            }`}
            title={v.hint}
          >
            <Icon className="h-3.5 w-3.5" strokeWidth={2} />
            {v.label}
          </button>
        );
      })}
    </div>
  );
}
